export default __webpack_public_path__ + "static/media/calendars_animation_128px.628eee11.webm";